<template>
  <div class="quiz_select_bg">
    <div class="content">
      <div class="question_wrapper">
        <div class="question_body">
          <happy-scroll>
            <div class="question">
              <div class="question_type">单选题</div>
            </div>
          </happy-scroll>
        </div>
      </div>
      <div class="button_wrapper">
        <div class="button click_able">确定</div>
      </div>
      <van-image @click="$emit('closeSelect', false)"
                 class="close click_able"
                 width="100"
                 height="100"
                 fit="contain"
                 src="/images/ico_close@2x.png" />
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import { Image, Row, Col, Dialog } from 'vant'
Vue.use(Image)
  .use(Row)
  .use(Col)
  .use(Dialog)
// @ is an alias to /src
export default {
  components: {},
  data() {
    return {
      single_choice: [],
      true_false: [],
      blank: []
    }
  },
  created() {},
  beforeMount() {},
  mounted() {
    this.single_choice = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12, 13]
  }
}
</script>
<style lang="less">
.quiz_select_bg {
  padding: 50px 210px;
  height: 100%;
  .content {
    position: relative;
    display: flex;
    flex-direction: column;
    height: 100%;
    .question_wrapper {
      flex: 1;
      height: 100%;
      .question_body {
        height: 100%;
        .happy-scroll-container {
          width: 100% !important;
          height: 100% !important;
          .happy-scroll-content {
            width: 100%;
            height: 100%;
          }
        }
        .question {
          padding: 100px 60px;
          .question_type {
            text-align: center;
            font-size: 40px;
            color: #fff;
            font-weight: bold;
          }
        }
      }
    }
    .button_wrapper {
      padding: 10px 0;
      display: flex;
      justify-content: center;
      align-items: center;
      .button {
        padding: 19px 118px;
        background: #ffd723;
        border-radius: 40px;
        color: #064134;
        font-weight: bold;
        font-size: 32px;
      }
    }
  }
  .close {
    position: absolute;
    top: 20px;
    right: 40px;
  }
}
</style>